var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _image, _g87, _image2, _g88, _image3, _g89, _image4, _g90, _image5, _g91, _image6, _g92, _image7, _g93, _image8, _g94, _image9, _g95, _image0, _g96, _image1, _g97, _image10, _g98, _g99, _image11, _g100, _image12, _g101, _image13, _g102, _image14, _g103, _image15, _g104, _image16, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _image17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1120px",
    height: "480px",
    viewBox: "-0.5 -0.5 1120 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(\"https://fonts.googleapis.com/css?family=Ubuntu+Mono\");&#xa;@import url(\"https://fonts.googleapis.com/css?family=Ubuntu\");"), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-55"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-3"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-4"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-6"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-8"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-9"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-12"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-13"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-14"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-15"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-23"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-24"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-26"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-27"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-28"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-29"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-30"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-31"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-32"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-33"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-34"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-35"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-36"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-37"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-38"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-39"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-40"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-41"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-42"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-43"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-44"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-45"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-46"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-47"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-48"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-49"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-50"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-51"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-52"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-53"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-54"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-55"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-56"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-57"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-61"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-62"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-1"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-2"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-3"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-4"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-5"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-6"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-11"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-12"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-13"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1120,
    height: 480,
    fill: "#192740",
    stroke: "none",
    pointerEvents: "all"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-5"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-6"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-7"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-8"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-9"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-10"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-11"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-12"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-13"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-14"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-15"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-16"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-17"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-18"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-19"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-20"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-21"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-22"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-23"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-24"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-25"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-26"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-27"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-28"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-29"
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 280,
    width: 80,
    height: 80,
    fill: "#a3ea2a",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #192740; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(25, 39, 64)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "A")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 181,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABPNJREFUeF7tm0uIHEUYx//fbOKKD3BCVrc3WUEJ2xMNKK6e1EwPGky8avCgiUGCijnoQQ8iGl94URAUXwcJJOAh8eor4E4P8SSKj2CY3iSwhuz0uigGH0jMzpT0ZI2zM9VdvSn7kvrPcer7auhf/ejq6X+3gB8SKJCAFDg3pyYBUDBKUCgBClYoXk5OwehAoQQoWKF4OTkFowOFEqBgheLl5BSMDhRKgIIVipeTUzA6UCgBClYoXk5OwTIc8PzgUQDvZGkiIve3mvUPqJKeAAXLFuxjAFsyBYPa34oa91EwCrYsB0auCy5b0cbPAIYNjb+Xh0ZWHzly4O9l/YAjxTyDpSz0qB/cK8CBXB6IbI6b9c9y1TpWRMFSFtzzg30AHsjjg0C93Yoau/LUulZDwbQrvnXI8+fnAVm1dFidAORqTcvJOArHXZMnz/FSMA2l0UoQiEJdM/QsgORMNTowJnJz3Kx/nQe6SzUUTLPanh+8DuCJ/iHpYBNK8rCC2jrYJi/FUf05l+TJc6wUTCtY9Tgg1/Ztj53T7UvKF6/4a7tSeFPT9l0chTfmge5SDQXrW+2r1gcbSh0cHpBA4Yd4OtywZqJ2Q0fUtzpJlOCauWY445JApmOlYH2EPD94BsDLGnDvx1G4E9hd8vzGLwCu0GyTj8dR/Q0TdJfGKdigYF8CuGXg+gvqoVbU2JN87/nVjwC5W1Mz1Yoad7gkkOlYKVgPodXrb/dWdoZmgcG3rdrt0rr5Y1PHu4JVqk9DySsauAvDpzEyMxOeMoF3ZZyC9ay0VwkegcK7msWfjaNw7b/fj/m1WxXUFzpJGH4vpULBegXzg5RwW/bFUX37udLJyZXeH5f/CuBSzTbJ8LsHCgVbhJEVbislD85N1/f2yuT5wScANmvOYgy/KdigFlnhdqmN8dlj4cnertFK8KQovKq9lpLSXXFz6qAr11lZx8kz2CIdz6/tBdQ2DayjcRRO9H/vVWqTUOor7XUYw+9zWChYF0VauN0dfC+OwuTJ1r5P935Y8rxYWSMZw+9FKBQsSa7Tw+3z3+UYfnfZUbDujVN9uH3+dgEi6sVWs7HbZo4LoZeCnb0zrwm3rZeX4TfPYEBquG3tF8Dwm1tksj2mhdv/g2LifPjt/Bbp+YE23AagFLDfZJkAawDcpqtTwOdzUXinaY4LedxpwbLCbQi+iZvhTabFX3t9sK69gKMpdc6H304LlhFuJ3+vX2tF4VMmwZJxz6/+mPIyCFwPv90WLDXc7mq1JY7CT/MINjYR7FGCHSl39Z0Ov50VLDPcBs6o4YvKP31/8M88gnkT1W0QWRKG/9enfisPXTni6pvfzgrmVWr3QKkPUwQ6FEfhxjxyJTXj/qaxBZxJHlTUfxwOv90VLD3cTv4+Pj83Hb6QV7Cz12FBE4Cfsk06++a3o4JlhtvJDYqN8XTj0HIEG/OrbynIYyk9zobfjgq2HHVYa0OAgtnQY6+RAAUzImKBDQEKZkOPvUYCFMyIiAU2BCiYDT32GglQMCMiFtgQoGA29NhrJEDBjIhYYEOAgtnQY6+RAAUzImKBDQEKZkOPvUYCFMyIiAU2BCiYDT32GglQMCMiFtgQoGA29NhrJEDBjIhYYEOAgtnQY6+RAAUzImKBDQEKZkOPvUYCFMyIiAU2BCiYDT32GglQMCMiFtgQoGA29NhrJPAP+6FLVA6YHhsAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-30"
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "B")))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 221,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABG9JREFUeF7t3N1rHGUUBvDn7G5jQbR+ZZJKETEtJJuCIhVBECIiQq9ERVrZ3RpBKlh6KSKFgCC1f4D0srbb3hQVrxSxQSMWoiCUkJ2UEvxAwSYrXVuokM3uHB28aFl3szM7M/By9tmb3Jx5ec95fjuBzLwR8MMJZDgByXBtLs0JgMCIINMJEFim4+XiBEYDmU6AwDIdLxcnMBrIdAIElul4uTiB0UCmEyCwTMfLxQmMBjKdAIFlOl4uTmAAquvF1X9/TETioGhC8DeABhQ/K3AFOV0obLYvvPrglT8jrTFERQQWF1gvHIoNAKdbgrlZz786RIa2bJXA0gJ2a8xXReXl0ljtIpGBD7tDBLF+RUZT02i1g8dnd17+JVq53SrewbIBBoF+WvJWXrJLJ1pnBNYf2OcA/rg1TrkTCB6Cyj4IRrYY86YGhV2V8aX1aFHYrCKwfsAk90x5dPmbzvhPNR67p9BsfgDB4V40gkCfOzS+csEmnWhdEdiAwMLxqkLO1qd+AGRft3EL5LWSVzsdLQqbVQSWAFhI4sx68bgA7/Tg8XrZ80/ZpBOtKwJLCOxsffqEqr7dbdwB8PQhz/8uWhQ2qwgsIbDqWnERgic7eaji2nYPO18Rv2mTTrSuCCwBsDNrxTdFcLLbqFVkrjJaey9aDHarCKwPMBU92G7pYkggLyoq2+7KS3tKVQ5A8EIPGouN682Zo3tWw8dHQ/0hsH53sJg8BPhyc9vIgdl7L/0V81KT5QSWFjDFPCAny2O1T0xKGbApAksLGPCTqs4jp+cqo5cXBszD3GUElh6w23Fc1FzujcoDyyvmxMRsiMCyARbGcF0DPF8Z97+PmYmpcgLrB6zjWeTXOlOo36jf3dzEBAJ9VoG3AOzqoeJ3DQqTlfGlm6bUxGiGwGIC65zt+WuP7Nhobf8KwBNd/x4GOVLxah/GyMRUKYElBBZqqK7tfQoS9HqD9Yuy5+83pSZGMwSWArDzivxGvRg+Esr9b/aKX8tj/sMxMjFVSmApAJtT5HbXp5qA5LvoaJQ9/z5TamI0Q2ApAKuuTT8K0Us95r5a9vw9MTIxVUpgCYGFLx2eq099rJAXe8hYKHv+jCk1MZohsATAquvTuwXBiS1whYc/jpW8lfdjZGKqlMD6AQM6Dn1oASo7VDApwGQfDUGrHUwM8/E1AusPbOA7igDHS57/7sALGLiQwLICppi/w8N+vtFq4FuStIW0T3YL8NHIKA4PO64wF97B0ruDKYBvA+DYsB/0uP0LT2CDAQv/fdON/05865JAfsznc58dvH/5t6R3U2vXE5i1RB3rh8AcC8TadgjMWqKO9UNgjgVibTsEZi1Rx/ohMMcCsbYdArOWqGP9EJhjgVjbDoFZS9SxfgjMsUCsbYfArCXqWD8E5lgg1rZDYNYSdawfAnMsEGvbITBriTrWD4E5Foi17RCYtUQd64fAHAvE2nYIzFqijvVDYI4FYm07BGYtUcf6ITDHArG2HQKzlqhj/RCYY4FY284/kJBhVNHZlPgAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-31"
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "C")))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    x: 261,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABVlJREFUeF7tnF1sU3UYxp/3lI8RjQm4doIIUfxgp4AfBBOiJBJiMMYrP2ai68ZiRIlR8cJEjaiLIQYvJHrBjca4bkNFMFzojYnBTxIEEkNouyghBCKupxPBsDnI6Xm1OJIFe1jfdr1Yz9PL7nne5P97f+u6s7MK+CCBOhKQOs7maBIABaMEdSVAweqKl8MpGB2oKwEKVle8HE7B6EBdCVCwuuLlcApGB+pKgILVFS+HUzA6UFcCFMyAt//00tn+qL/cickiUcwOABHBKUUwUDw7uq/r+mOjhnGRiFKwCdacHlx2BZziOlFNQbACgBNSGRaRz31ft6ybm81Ewp4KDknBQiC9rnAWFZIbBNoN4OoKWF6M+BDZqsVYd8c1h4YNvYaMUrAya00PLkvA8T8RYHUNW/8VkPtTicyRGmZM+SoFu2SFPafcBY6PrwHcOAnbHfKLwYquuQPHJmHWlBxBwcatbceJ+bPOzbxqH4Clk7JNRX97IpsSgU7KvCk4hIKNW1qv1/oRIJ0V7HFYFaVXpWERzAcw79KOAnua4rivTbLnK5jXsBEKNrba3nzyIYjuvOymFVmFs+n0X6NfPnfTkXMXs/2ee1sAvAygrfScKjJN00fvaptz9EzDmlPhwSjYf0JIX8E9BGBJGDcFPmyKY8PlXpF6Pbck2OZgGtZ0zsker3AHDR2jYAAmevUS4LPH49lHK3kvtUfvmbZavvEb2hrD4ShYSTDP/Q7AqhBuheB80No5f+APA1dGxwhEXrDt+SUtRQlOhl2hF+ir7YncZhpTHYHICzb2vunTEHyBD1zblcgOVoeXLQpWSL4N1RfLqaDQQx2J3K3UpHoCkResz2vdpZAHywqm+n5HS2599XjZpGCeu1eBlWVVUHSnWrJvUJPqCUResF7vwvWvkD8N6cZUIvdu9XjZpGB5NwOBW14FClbrt0jkBUt77gEBlpcFKfJaKp55s1bIUe5HXrBeL/kVoPeWl0C2pRKZZ6IsSK1np2Ce+wGAJ0JA/phKZO+uFXKU+5EXLF1IviCq74RIMDLiz4o/Ne/gSJQlqeXskResJ794pSPO3jCIoki1t2T7aoEc5W7kBduhiJ0ruL8DiIddzW+K5+5oExSjLEq1Z4+8YCVwaS+5VaAbwyAq8EpHIvtWJZD7C4uX+xIMdjb/8lsl+UbPUDAAHxdumecHsaMQzAxZuEJ0fSqeK/1CEPpI55NrRXQHgOP+9Bmrumb/fLrRBZrofBRsjFBvIbkNqhsmALZLHNnS3pzZPz7X47m3O8CzALrGPf/tn2fOrx1/a/VEy2jEr1Owsa1uP3lzczE27SAECypYtKfACcGFz7gt/dNHIqSz88i/d8J2C4IKZjZkhIKNW2vfUHKFFvX7y/yorEIC3ZJK5F6qotgQFQp2yRrTnvuIAGkATZOw4bOBgzWdzdmfJmHWlBxBwcqsrWfIvdMJsBvA3Bq2mldxHuiIHz5Qw4wpX6VgISss3asfSHGTqjwJwQzTphW7Y3CefqzlcN7Ua8AwBZtgqf0nWxcGMTyvIg8LcF14XP8WyBdF4L3ORPaHBnSlqiNRMAO2/sGlNwTiL4NgoQBXBpDAERlS1QF/eGQ/P4Du/zApmEEwRu0EKJidGRsGAhTMAItROwEKZmfGhoEABTPAYtROgILZmbFhIEDBDLAYtROgYHZmbBgIUDADLEbtBCiYnRkbBgIUzACLUTsBCmZnxoaBAAUzwGLUToCC2ZmxYSBAwQywGLUToGB2ZmwYCFAwAyxG7QQomJ0ZGwYCFMwAi1E7AQpmZ8aGgQAFM8Bi1E6AgtmZsWEgQMEMsBi1E/gHsBpgVD70V0oAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-32"
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 301
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "D")))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    x: 301,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABAtJREFUeF7t3E9oFGcYx/Hfs7vVg4Jo3dmAIPQgJZNab6UHDyp6UbBYRFvdNyL2UAr1VtBbxYMognjyoIjZTa2IQutFtJYoNKeWoq0zeymFlkKdjX8gVPBf8sioVCOZyZqd57LvL7C3mQfe737y7mSZiYA/LGBYQAxnczQLgMCIwLQAgZnm5XACowHTAgRmmpfDCYwGTAsQmGleDicwGjAtQGCmeTmcwGjAtACBmeblcO+BNdvhCQC7ZqDwGMC9F6/bCvxago6i/NZo/e3f/iGj7AIE1hmwHEN6GSgdqVejSyJQYptagMC6BvZ/0J9Lk+VPtvf9/ieRvSxAYMUBS6uOC2RXPYjOEdnzAgRWLLC0qYpIvV6NThMZgWGGi/z0wv4ugHlQLIRgbodoHkDlQ1eLbnR4fM8exh0sbwdT7HO1+Otn25JCvr2z/N0nExOrRPA5gBX5KvSXerX1ge8X/gTWIbDXMQ23wy9VcRiCOZnQVDa7WnS+Z7enDhZGYLMElrYdTsK6Cpo5na+5IF7VwfvQs4cQWBfAUhWNJPxGBNsyhChEl7hq69+eFTTDwgisS2DNZGAFRK9ndVZg52AQnyIwTwvk/hX5ykV+Xp5GEt4UwcC0x4gcc9XoC0/z8nuwIoA12wPHAf1sOkQKjAwG8RoC87RAEcAa7XC3AEczEv7hgniZp3m5gxUBrJn0D0JkKAPRbRfEVQLztEAhwMbCjVB8n5Hwvgvi+Z7m5Q5WBLBG8t7HIpNZX6iOuyBeQGCeFigCWLMd7gRwMiNh4oK4z9O83MEKAZb0fwWRQxmIbrogXk5gnhYoAlijPXBGoFszEl50Qbze07zcwYoA1kzCvyBYOj0iPeiC1h4C87RAt8CGbvWvLZXkh8x8qptcrfWdp3m5g3UDLL1HrDkW/ijA6mkBKR7OFSzeEsT/EZinBboBNtwO9yhwICfdWRfEWddmXhTn3RSzuJvirKL8aCzcr8DePCWisrJei0a9kJSxSALrEFj6cTh0KwwrFV2nKrsBvJMLR3HB1eKPfMaVrp3A8p8qevWhj0W5t0dPlXRPypX3+dQ3gc30VNGbb0CKR5OqG3b0ta68+cm9dwZ3sGKfixwriWzdXo1Geo/K7FZEYMUB+0nKlU/5sTgVIoF1CSy9Y1VUD7haK/vL1tn98vfEWQTWGbD0v+aMA7iTvgSIALk6UdGRHYviv3tCgtEivAdm1JVjXxQgMFIwLUBgpnk5nMBowLQAgZnm5XACowHTAgRmmpfDCYwGTAsQmGleDicwGjAtQGCmeTmcwGjAtACBmeblcAKjAdMCBGaal8MJjAZMCxCYaV4OJzAaMC1AYKZ5OZzAaMC0AIGZ5uVwAqMB0wIEZpqXwwmMBkwLPAWYRmlUkDywWAAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-33"
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "E")))), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    x: 341,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAetJREFUeF7t2iFOQ0EYhdF5qgKBatkDa0CArEVUUTw7wsMikJBAWEHfHjDVpJAUwwL+TnoFj4OeuYGvhzEwNF8KBAsMwW3TCjTAIIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWgBwKJ5jQP2a+Dx4/xmP7SH45EYluvF5ul4e39zCTDAonIBAwywaAHAonm9YIABFi0AWDSvF6wAbGjt/au160M+iZN5266GcXfInSmeBawArLX2sl6Ml1MEkP6ZAAMsagwwwACLFgAsmtcLBhhg0QI1YOVvYb9vd7dn4335wsQPesEAixIHDDDAogUAi+b1ggEGWLQAYNG8XrAasNdZa8vKJzGfLz6vhufvytn/cAawGjB/i+z8bQAMsE46tWuAAVaT0nkKMMA66dSuAQZYTUrnKcAA66RTuwZYAVjXv0zPht3qdLOtfQzTPQVYAVjnx/+2XowXnXcncw0wwKKYAQMMsGgBwKJ5vWCAARYtAFg0rxcsmtc4YAxECwAWzWscMAaiBQCL5jUOGAPRAoBF8xoHjIFoAcCieY0DxkC0AGDRvMYBYyBaALBoXuOAMRAtAFg0r3HAGIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWiBH4qG1EV5clnEAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-34"
  }, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 381
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "...")))), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    x: 381,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABDpJREFUeF7tl02IW1UYht9zk45WoUgzScZSF4I6k5taiqJScCO48Lf4UyvWJLVUEFzpQsFd60pduRFRxJ/JjEpQS8tYcSN1I6hURGeSOitrqzg3jlXqdNpMcj/JpgzpvZnZfIvv3jfbc86X9zzvw5mMAz8koEjAKc7maBIABaMEqgQomCpeDqdgdECVAAVTxcvhFIwOqBKgYKp4OZyC0QFVAhRMFS+HUzA6oEqAgqni5XAKRgdUCVAwVbwcTsHogCoBCqaKl8MpGB1QJUDBVPFyOAWjA6oEKJgqXg6nYHRAlQAFU8XL4RSMDqgSoGCqeDmcgtEBVQIUTBUvh1MwOqBKgIKp4uVwCkYHVAlQMFW8HE7B6IAqAQqmipfDKRgdUCVAwVTxcjgFowOqBFIl2Htnd1yTXelUHGQC8M6KCw9X860f1iLcEGQ67dJugbcTIj3x3PHq6NyMc5C1ztaD8g0O4eMCb4tIeEoyvel9o/O/r3UuKeupEazeLt0CcccAFFeVJxC8XC02D8YV2vi3vPniBTkGhzsG9nzRXTr/yP7rf70Qd3Yy8J9ywNsANqzasySQPbVCq58l8Z9UCNY4vXXjxSs2zQPYGtVoGOKhfWPNI1Fr9cD/BMCjUWsC93qtMPd81Np04O8Ige8BZCPW/3OZbKmS++lM0g1LhWBTC35FHOrxZcrxaqF11+D6R4vbruv2wt+GnFvuLi1vjnrF6oH/DoADsWcFB6vF5iEKlgAC9Xb5NYi8EHcVEfxdKzZzg+uTQek+B/f5MAQuDLdXxk7+PLinHvjfAbgt7qyDfFYptCJfxgQgv3SFdLxg7fKrIvLikOIWq4Xm6OD6VODfK8DQ30oSys21sdbsZXIu+N86h9uHfOen1UJzd5JkirpLKgSbDPzHHNCIf03wZaXQvGdw/cOFbcWeC/8A4MWcPXc+vzH3jDuxcvkLVn4DkGeHfOdLlULzFQqWAAJvya0brmov9/+MjUdcR8Rzd9dG576K+ZH/LoD9kRgEh+L+A623x8chmR8BXBlxdjHT7U7s3TL/VwLwDr1CKl6wPoHpoHRjCDcD4KZLRAQdQJ6rFltvxlGa/HP71fBWPnZwD6ze44D3R/LNp/c49GLPtssPOpEpAJtW7Qkg3sPV4uw3SZerf7/UCNa/bEP8kU4g94fOTTiRf7LZzMwTudnT6yn6g8C/0xPZCc/1PIRfP5k/eWJd585M5LwRbxeAayE41fF6Rw/kfzm3nrNJ2JMqwZJQmLU7UDBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi0uBbPWmLG8FMxYYdbiUjBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi3u/8iU/0XA7WPPAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-35"
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 301
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "G")))), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    x: 301,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABUNJREFUeF7tnF9oHFUUxr+TTRoatZba2VVIicWUNrOxFIMW31pBEKqoiAWb7LZSEEWo0of650ESi1QQxQfBBtFqdlckFH3JQ33Q+gcEWykEuhNrWwy2tu6sUbSlydrsHN20BZPObCbZXS6758xj9pxzOd/3u7N37t4JQS9VoIYKUA1ra2lVAAqYQlBTBRSwmsqrxRUwZaCmCihgNZVXiytgykBNFVDAaiqvFlfAlIGaKqCA1VReLa6AKQM1VUABCynv+/m1Ny1BSw9Q7GQPK5oILQxcZI6c8YDRHbHjp0OWEhWmgJWxe9i1b5wCbSd42wBsBChSJvwkmN9rJXp3a9S5KIqiMs0qYD7iDHJPS5t76XkQvQxg+QJhOcvc9FwydvzTBeY1ZLgCNsfWD3Pdd0TIGwZwV0WOMzJ//v3Pzl1rThUqqlPnyQrY/wzM5Nf1eNx0CMDKqvjK+KIv6txPBK5KvTosooBdNS09sb6di9PHAFhV8pGJqK/Pyn5cpXp1WUYBAzDM9pIpF98S4Z75XeRJgH4h4A8GbgF4FUBL5+YR8FJf1Hl9/nqNHaGAARhy7X0EvFjeav4BjNemL00eenL1+NS12OEz7UsLrcseAvAqgLUzf2cMJmLO042NTrjuxAM29Nv6KDVN/wygLVAyRv+pqLN3gOAFxcw8eean3gbQ0WplH95KKIazoLGjxAOWytlvgrC7DFwDiZjTHxaDw7ypeTN9NR02vtHjRAM2eK6nra150gVwQ4DRR1st5169Gy1+GogGLJWLPwbig0HyMdMDyVj288XLq5miAUu7Xe8w6NkADE73Wc4ayXtY1ZgeogEbytnfB21NMGN/MuY8Uw2RJdcQDVjKtX/HzF7W9RczJ5OxsZRkOKrRu1jASpurhTwCfydsIrqv18oe9hM5lbPHQegIZYDwPTG5gP0VX1Eo8ETw9gRtSMSyowpYqGkUGCQWsA/Od1otkSWlLQr/ixWwytC6ki0WsNJhwgJwIZgvb1PS+vFrvYNVhplYwJhBadeeBKHVd5FP/ETSGvtEAVPAFq1AyrVPAuj0LUD0RsLK7vEFzO06CtCqWZ8xlvvCqov8RftT94mpnP0ZCI/4b1PgSDLmbAzbZMqNjwC85bp4BSyshI0Xl3LjLwAceGarWET3jtucbJjOFTB/lcSuwUpypCfiNhe5HEAHE1HncQUsjAIKmK8CKdc+AuDuIAmJqDfMsWe9gylg/oDlu7aAaaTMHC2d7XoqEXUOlJvHCpgCFsjHfHexq4nfeB7emo4Uv9xpnZi1f5bJxzd7zEMA2nWRP1sB0Wuwa1JkXHuDB/7O7+UNHyovAzjLjDxd2UNbDWBZIL36FLn4BVwjZabz8W3MnKl6TwpY1SWt24JDua49RLTvvzeEmqrWBNErCSu7t2r16qyQfkXOMSyd736Q2UsDuLkyL3mSmXYnY87+yurUd7YC5uNf5lxXBzdTP4MT8/xHHZ9sLr2ulmbPG0jeeqL0OpzoSwErY3/KjXcyeBcBj/o+Ic7OHWXQSATeR73RsdJvnHpJPq6zUPcPnF93e6Q5cicxl06yzjw1EnDBIxpnunxs+8qffl1oTQnxegeT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEeFTCD4ksYWgGT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEeFTCD4ksYWgGT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEeFTCD4ksYWgGT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEe/wWSB5ZUDjwpdQAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-36"
  }, _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "H")))), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    x: 341,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAglJREFUeF7t27FNA2EMhuH/psgO0LAHK5CKEVgA9qCDGhpmyRBZ4pDS0CQkxf9ZSvykPtny61e2dacsww+BIIElGFtoBAbBSBAlQLAoXsEJxoEoAYJF8QpOMA5ECRAsildwgnEgSoBgUbyCE4wDUQIEi+IVvLVgH/u79zHG81EN1vG23exeL1HkY3//M8b6eOzZZR3bp83u85I4t/gMwQgW9ZpgBCNYioAVmSL7F9cEM8GilhGMYARLEbAiU2StyAMBghEsSoBgUbyH4G4wN1jUMoIRjGApAlZkiqwj//yRP4m9b5GTQF5jmH8n2KSCCDYJ5DWGIVi+a478U0f+JPYm2CSQ1xjGBMt3zQQzwaKWEey0YN/LOr4uob8u42WM8XDsWSvyEoI3+oz3YPnGmmDe5EctIxjBCJYiYEWmyPpUdP5Tkb+tTbHPirQip4h0KgjBCEawFAE3WIqsG8wNlnfrkMGKtCKjqhGMYARLEXCDpci6wdxgebfcYEWMW6dpfYO17nxR8QQrAt01DcG6dr6oboIVge6ahmBdO19UN8GKQHdNQ7CunS+qm2BFoLumIVjXzhfVTbAi0F3TEKxr54vqJlgR6K5pCNa180V1E6wIdNc0BOva+aK6CVYEumsagnXtfFHdBCsC3TUNwbp2vqhughWB7pqGYF07X1Q3wYpAd01DsK6dL6r7F0Zuc1RDhTQ1AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-37"
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 120,
    width: 80,
    height: 80,
    fill: "#ff8000",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #192740; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(25, 39, 64)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "D")))), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    x: 181,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABAFJREFUeF7t3E+IE3cYxvHnnS3tQUGUFjYRBA9mxNJ6kx6ETEQvChZF0RYRxB5Kod4Keqt4EEUQTx4UUUQRUbBeSq2SX6h7qoiC1Z1VCi01E3XtwqLgv+StUbGuZGZDMu8lvyfn5IX57mffnR1mIuCLBQwLiOFsjmYBEBgRmBYgMNO8HE5gNGBagMBM83I4gdGAaQECM83L4QRGA6YFCMw0L4cTGA2YFiAw07wc7j2wQhgdBrA1i4ICzwU6AcgEgHFVuRpAR6SFkbt33D9klF6AwLoAlg1ILwCyP4ndLwCU2KYWILC+gb0N+nuzNbTx/u1LfxLZ/wUILD9g7QU2qZCtjdidIbLXBQgsV2CvmqqIbKqPVk8SGYFhmpP89kn9vwBmAJgN4KMu0TwJVL64O1a93uX7B/Zt3GAZG0wEO+uj7sc3P30plqJQBRGAbwEsnkbFlSR2S3w/8Sew7oFN8VRcWP5eFfsA+TAVmsi6ZLR6dmDXUxcHRmA9Amu3LYTRJgDHMzrXkti1N563LwLrA9hrZOUTgHydIkifB82547d+S3wVRmB9AptbqixuiV5LA6SCLY1Rd5TAPC2Q9V/keyf5qYUKpegGBJ92foMcTOLqd57m5XWwXICF0SEA33RCJEC1HrtlBOZpgXyAVbYBeqBTQlXcaYy5BZ7m5QbLA9hwqbJZRI+lIBpPYvcJgXlaIA9gxbCyWqE/pSR8nMRupqd5ucHyAFZYWFkL1ZQLqjqZxLVZBOZpgTyAFcPyFoUc6ZhQcS8Zc8Oe5uUGywPYcFj+QSB7UxDdSGL3GYF5WiAfYNEpATakJPw5id1KT/Nyg+UBrBCW/wJkXsfLFMCeRuy2E5inBfoFVlwQLdcAv6blE8Wa+pg752lebrA+gUkxjC4pUEkB9PTFED5+cNM9IjBPC/QDrFCKtkOwO3V7QU/X41rauZkXxXk3RU93U6wfKpTGd0F0R5YSgSytx9URLySlHCSBdQ9MhhdVFklTV7y8T38bgPlZcBR6vhHXvvQZV/vYCSz7qaJ3HvrQOZm3R0+VNBE08Tmf+iaw6Z4q6mEB6TNpyar6bXexhw8P3Ee4wfJ9LvKBQjc04lp14KT0eEAElh+wy0ETX/HP4lSJBNYnsPYdqwh0d/1WLfVia4+//APxMQLrDlj7W3MmAX0IyENR/NEK4CT4oJrcvPj3QEgwOgjvgRl15dg3BQiMFEwLEJhpXg4nMBowLUBgpnk5nMBowLQAgZnm5XACowHTAgRmmpfDCYwGTAsQmGleDicwGjAtQGCmeTmcwGjAtACBmeblcAKjAdMCBGaal8MJjAZMCxCYaV4OJzAaMC1AYKZ5OZzAaMC0AIGZ5uVwAqMB0wL/AbIeWFSV+Go/AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-38"
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "E")))), _image0 || (_image0 = /*#__PURE__*/React.createElement("image", {
    x: 221,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAetJREFUeF7t2iFOQ0EYhdF5qgKBatkDa0CArEVUUTw7wsMikJBAWEHfHjDVpJAUwwL+TnoFj4OeuYGvhzEwNF8KBAsMwW3TCjTAIIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWgBwKJ5jQP2a+Dx4/xmP7SH45EYluvF5ul4e39zCTDAonIBAwywaAHAonm9YIABFi0AWDSvF6wAbGjt/au160M+iZN5266GcXfInSmeBawArLX2sl6Ml1MEkP6ZAAMsagwwwACLFgAsmtcLBhhg0QI1YOVvYb9vd7dn4335wsQPesEAixIHDDDAogUAi+b1ggEGWLQAYNG8XrAasNdZa8vKJzGfLz6vhufvytn/cAawGjB/i+z8bQAMsE46tWuAAVaT0nkKMMA66dSuAQZYTUrnKcAA66RTuwZYAVjXv0zPht3qdLOtfQzTPQVYAVjnx/+2XowXnXcncw0wwKKYAQMMsGgBwKJ5vWCAARYtAFg0rxcsmtc4YAxECwAWzWscMAaiBQCL5jUOGAPRAoBF8xoHjIFoAcCieY0DxkC0AGDRvMYBYyBaALBoXuOAMRAtAFg0r3HAGIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWiBH4qG1EV5clnEAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-39"
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "F")))), _image1 || (_image1 = /*#__PURE__*/React.createElement("image", {
    x: 261,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAgdJREFUeF7t2TFKnGEUheHvVyGVXRT7dNlF1iCkU9ybG0nlAiRMlQ1ESGfrTCBVyjMHb+HwWN97wfd/+JrZlj8FBgtsg7edVmABBsFoAcBG8zoOGAOjBQAbzes4YAyMFgBsNK/jgDEwWgCw0byOA8bAaAHARvM6Dth/Bh5fvv5aa315JxZ/7q53n9/p1oc9Axhgo3gBAwyw0QKAjeb1ggEG2GgBwEbzesFCYIfD2e3btn9Kv8b5/mJ/f/P8ks6f6hxgIbC1nX27u/r541QhTP1fgAE2ZevfXcAAA2y0AGCjeb1ggAE2WgCw0bxesBTYEZ/h01qX3693r0esnOwoYICN4gYMMMBGCwA2mtcLBhhgowUAG83rBQuBHfNj98PV7ve2rcPol/sgxwELgfmxuxMNGGCdnHALMMBCKt0YYIB1csItwAALqXRjgAHWyQm3AAMspNKNAQZYJyfcAgywkEo3BhhgnZxwCzDAQirdGGCAdXLCLcDCUMa6AoB13WyFBQALQxnrCgDWdbMVFgAsDGWsKwBY181WWACwMJSxrgBgXTdbYQHAwlDGugKAdd1shQUAC0MZ6woA1nWzFRYALAxlrCsAWNfNVlgAsDCUsa4AYF03W2EBwMJQxroCgHXdbIUFAAtDGesKANZ1sxUWACwMZawrAFjXzVZYALAwlLGuAGBdN1thgb96BK1FK1NE8AAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-40"
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 381
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "...")))), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    x: 381,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABDpJREFUeF7tl02IW1UYht9zk45WoUgzScZSF4I6k5taiqJScCO48Lf4UyvWJLVUEFzpQsFd60pduRFRxJ/JjEpQS8tYcSN1I6hURGeSOitrqzg3jlXqdNpMcj/JpgzpvZnZfIvv3jfbc86X9zzvw5mMAz8koEjAKc7maBIABaMEqgQomCpeDqdgdECVAAVTxcvhFIwOqBKgYKp4OZyC0QFVAhRMFS+HUzA6oEqAgqni5XAKRgdUCVAwVbwcTsHogCoBCqaKl8MpGB1QJUDBVPFyOAWjA6oEKJgqXg6nYHRAlQAFU8XL4RSMDqgSoGCqeDmcgtEBVQIUTBUvh1MwOqBKgIKp4uVwCkYHVAlQMFW8HE7B6IAqAQqmipfDKRgdUCVAwVTxcjgFowOqBFIl2Htnd1yTXelUHGQC8M6KCw9X860f1iLcEGQ67dJugbcTIj3x3PHq6NyMc5C1ztaD8g0O4eMCb4tIeEoyvel9o/O/r3UuKeupEazeLt0CcccAFFeVJxC8XC02D8YV2vi3vPniBTkGhzsG9nzRXTr/yP7rf70Qd3Yy8J9ywNsANqzasySQPbVCq58l8Z9UCNY4vXXjxSs2zQPYGtVoGOKhfWPNI1Fr9cD/BMCjUWsC93qtMPd81Np04O8Ige8BZCPW/3OZbKmS++lM0g1LhWBTC35FHOrxZcrxaqF11+D6R4vbruv2wt+GnFvuLi1vjnrF6oH/DoADsWcFB6vF5iEKlgAC9Xb5NYi8EHcVEfxdKzZzg+uTQek+B/f5MAQuDLdXxk7+PLinHvjfAbgt7qyDfFYptCJfxgQgv3SFdLxg7fKrIvLikOIWq4Xm6OD6VODfK8DQ30oSys21sdbsZXIu+N86h9uHfOen1UJzd5JkirpLKgSbDPzHHNCIf03wZaXQvGdw/cOFbcWeC/8A4MWcPXc+vzH3jDuxcvkLVn4DkGeHfOdLlULzFQqWAAJvya0brmov9/+MjUdcR8Rzd9dG576K+ZH/LoD9kRgEh+L+A623x8chmR8BXBlxdjHT7U7s3TL/VwLwDr1CKl6wPoHpoHRjCDcD4KZLRAQdQJ6rFltvxlGa/HP71fBWPnZwD6ze44D3R/LNp/c49GLPtssPOpEpAJtW7Qkg3sPV4uw3SZerf7/UCNa/bEP8kU4g94fOTTiRf7LZzMwTudnT6yn6g8C/0xPZCc/1PIRfP5k/eWJd585M5LwRbxeAayE41fF6Rw/kfzm3nrNJ2JMqwZJQmLU7UDBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi0uBbPWmLG8FMxYYdbiUjBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi3u/8iU/0XA7WPPAAAAAElFTkSuQmCC"
  })))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 399.5 220 L 399.5 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 394.17 239.53 L 399.5 255.53 L 404.83 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-42"
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "A")))), _image11 || (_image11 = /*#__PURE__*/React.createElement("image", {
    x: 61,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABL5JREFUeF7t20uIHFUUBuD/9CQZUBeO2lWJGkEZjFM9oBhdKUFQMXHra5G5bSKiQRe60IWIxhduFATFRxYS6BoVRrc+QV3ElSjGmK4MBMGEBOzqiKKIGmf6aM1MYLr71mNo7ib372Xfe89Q//2oqqnTJeCHCThMQBzWZmkmAAIjAqcJEJjTeFmcwGjAaQIE5jReFicwGnCaAIE5jZfFCYwGnCZAYE7jZXECowGnCRCY03hZnMAKDLQ60R4RvFnERER2ztTb75KSPQECK5ARp9FHAHaU4JkzQXIPgRHYmgzMpdF5/yhOQTBesvCP8TouuluS02v6A55M5hksZ6Nn08adCn2/igNV2d4M259WmevbHALL2fG4G8VQzFQDIW+YoP1wtbl+zSIwy37PKcb+TqNUBBf0DSuOQ3CZZckJEySb/aJT7WgJzJJT3J2+Cdr7cnBIoU8JJDtTbRwcq0nvup31+W+rxe7PLAKz7HUrbbwi0EcHh3o9vXWsJg8ocNfQMtXnTXjkaX/oVDtSArOdwdLoRwBXDAz1ZOz0hC5uaAJ4zbLsexMk11SL3Z9ZBDaw162fp6alJj8MXR4V7WaYTMedxtUQPWgjsrDYu3z3pvmf/OFTfqQENpDRbDr1pEJesET3tgmS+/cqapPd6BcA5w/fo+GRZpC8Wh67PzMIbGCv4zT6GsD1FgL3mSDZn30fp9GHAG4fvg/DFyZMbvaHT/mREtiqjOLu1CaonASG37Za1NrkrvBwdm+GVho9IcCLlngXFtZvqO+eOPhbefR+zCCwPmDRg1C8Zdn6kyZILj3z/WyncYOKfmUjwuZ3fyoEthpYTnNbROKZejv773Hps0+3rj+n+9evAM61IGPze1UoBLYSRmFzW/VeEx5prcYUp9HHALZbgLH5TWDDLIqa2zK2bvPMhYdO9AHrRI9B8JL1Mqm122bCw5/5cZdVfJQ8g63kM9tttFTVWOI6aoLkysHv3+letbWntW/s8bL5fSYXAgOQ29zOUlLsM2GyZxDSyvOwUwAmLMjY/F4JhcCy51o5ze1RLnFsfi+nR2BLz7Xsze1RgKniuWaY7B2lxtmwlsCWn8zbmtuj7i+b3zyDAXnN7VF1ZevZ/OYlEgXN7ZGNKdj89v4SWdDcVoXMlSkT6CUAbrTOU3xuwuSWshpn87jXwIqa2wC+M0Fybdnmx2ljEtCjOfO8b357Diy3uZ3dPLxs6snjZcCy8bgTHct5GQS+N7/9Blb45rbsMEH7kyrAZtNovwK7cuZ63fz2FljJm9v/am/dRHPjoT+rAGt1poyI9DXDV637fbyOuq9vfnsLLO407oDoBzmADpgg2VYFVzbnve6Wixd0LPuhovUjHje/vQVW0NzO+o/PmDB5tiqwpfuwNJr/39qWHGLevvntJbDC5vaykG0mSA6sDVjjdUAfylnjbfPbS2BrgcO5oyVAYKPlx9UlCRAYiThNgMCcxsviBEYDThMgMKfxsjiB0YDTBAjMabwsTmA04DQBAnMaL4sTGA04TYDAnMbL4gRGA04TIDCn8bI4gdGA0wQIzGm8LE5gNOA0AQJzGi+LExgNOE2AwJzGy+IERgNOEyAwp/GyOIHRgNMECMxpvCz+H6mHYFRTt/V9AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-43"
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 101
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "B")))), _image12 || (_image12 = /*#__PURE__*/React.createElement("image", {
    x: 101,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABG9JREFUeF7t3N1rHGUUBvDn7G5jQbR+ZZJKETEtJJuCIhVBECIiQq9ERVrZ3RpBKlh6KSKFgCC1f4D0srbb3hQVrxSxQSMWoiCUkJ2UEvxAwSYrXVuokM3uHB28aFl3szM7M/By9tmb3Jx5ec95fjuBzLwR8MMJZDgByXBtLs0JgMCIINMJEFim4+XiBEYDmU6AwDIdLxcnMBrIdAIElul4uTiB0UCmEyCwTMfLxQmMBjKdAIFlOl4uTmAAquvF1X9/TETioGhC8DeABhQ/K3AFOV0obLYvvPrglT8jrTFERQQWF1gvHIoNAKdbgrlZz786RIa2bJXA0gJ2a8xXReXl0ljtIpGBD7tDBLF+RUZT02i1g8dnd17+JVq53SrewbIBBoF+WvJWXrJLJ1pnBNYf2OcA/rg1TrkTCB6Cyj4IRrYY86YGhV2V8aX1aFHYrCKwfsAk90x5dPmbzvhPNR67p9BsfgDB4V40gkCfOzS+csEmnWhdEdiAwMLxqkLO1qd+AGRft3EL5LWSVzsdLQqbVQSWAFhI4sx68bgA7/Tg8XrZ80/ZpBOtKwJLCOxsffqEqr7dbdwB8PQhz/8uWhQ2qwgsIbDqWnERgic7eaji2nYPO18Rv2mTTrSuCCwBsDNrxTdFcLLbqFVkrjJaey9aDHarCKwPMBU92G7pYkggLyoq2+7KS3tKVQ5A8EIPGouN682Zo3tWw8dHQ/0hsH53sJg8BPhyc9vIgdl7L/0V81KT5QSWFjDFPCAny2O1T0xKGbApAksLGPCTqs4jp+cqo5cXBszD3GUElh6w23Fc1FzujcoDyyvmxMRsiMCyARbGcF0DPF8Z97+PmYmpcgLrB6zjWeTXOlOo36jf3dzEBAJ9VoG3AOzqoeJ3DQqTlfGlm6bUxGiGwGIC65zt+WuP7Nhobf8KwBNd/x4GOVLxah/GyMRUKYElBBZqqK7tfQoS9HqD9Yuy5+83pSZGMwSWArDzivxGvRg+Esr9b/aKX8tj/sMxMjFVSmApAJtT5HbXp5qA5LvoaJQ9/z5TamI0Q2ApAKuuTT8K0Us95r5a9vw9MTIxVUpgCYGFLx2eq099rJAXe8hYKHv+jCk1MZohsATAquvTuwXBiS1whYc/jpW8lfdjZGKqlMD6AQM6Dn1oASo7VDApwGQfDUGrHUwM8/E1AusPbOA7igDHS57/7sALGLiQwLICppi/w8N+vtFq4FuStIW0T3YL8NHIKA4PO64wF97B0ruDKYBvA+DYsB/0uP0LT2CDAQv/fdON/05865JAfsznc58dvH/5t6R3U2vXE5i1RB3rh8AcC8TadgjMWqKO9UNgjgVibTsEZi1Rx/ohMMcCsbYdArOWqGP9EJhjgVjbDoFZS9SxfgjMsUCsbYfArCXqWD8E5lgg1rZDYNYSdawfAnMsEGvbITBriTrWD4E5Foi17RCYtUQd64fAHAvE2nYIzFqijvVDYI4FYm07BGYtUcf6ITDHArG2HQKzlqhj/RCYY4FY284/kJBhVNHZlPgAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-44"
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "C")))), _image13 || (_image13 = /*#__PURE__*/React.createElement("image", {
    x: 141,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABVlJREFUeF7tnF1sU3UYxp/3lI8RjQm4doIIUfxgp4AfBBOiJBJiMMYrP2ai68ZiRIlR8cJEjaiLIQYvJHrBjca4bkNFMFzojYnBTxIEEkNouyghBCKupxPBsDnI6Xm1OJIFe1jfdr1Yz9PL7nne5P97f+u6s7MK+CCBOhKQOs7maBIABaMEdSVAweqKl8MpGB2oKwEKVle8HE7B6EBdCVCwuuLlcApGB+pKgILVFS+HUzA6UFcCFMyAt//00tn+qL/cickiUcwOABHBKUUwUDw7uq/r+mOjhnGRiFKwCdacHlx2BZziOlFNQbACgBNSGRaRz31ft6ybm81Ewp4KDknBQiC9rnAWFZIbBNoN4OoKWF6M+BDZqsVYd8c1h4YNvYaMUrAya00PLkvA8T8RYHUNW/8VkPtTicyRGmZM+SoFu2SFPafcBY6PrwHcOAnbHfKLwYquuQPHJmHWlBxBwcatbceJ+bPOzbxqH4Clk7JNRX97IpsSgU7KvCk4hIKNW1qv1/oRIJ0V7HFYFaVXpWERzAcw79KOAnua4rivTbLnK5jXsBEKNrba3nzyIYjuvOymFVmFs+n0X6NfPnfTkXMXs/2ee1sAvAygrfScKjJN00fvaptz9EzDmlPhwSjYf0JIX8E9BGBJGDcFPmyKY8PlXpF6Pbck2OZgGtZ0zsker3AHDR2jYAAmevUS4LPH49lHK3kvtUfvmbZavvEb2hrD4ShYSTDP/Q7AqhBuheB80No5f+APA1dGxwhEXrDt+SUtRQlOhl2hF+ir7YncZhpTHYHICzb2vunTEHyBD1zblcgOVoeXLQpWSL4N1RfLqaDQQx2J3K3UpHoCkResz2vdpZAHywqm+n5HS2599XjZpGCeu1eBlWVVUHSnWrJvUJPqCUResF7vwvWvkD8N6cZUIvdu9XjZpGB5NwOBW14FClbrt0jkBUt77gEBlpcFKfJaKp55s1bIUe5HXrBeL/kVoPeWl0C2pRKZZ6IsSK1np2Ce+wGAJ0JA/phKZO+uFXKU+5EXLF1IviCq74RIMDLiz4o/Ne/gSJQlqeXskResJ794pSPO3jCIoki1t2T7aoEc5W7kBduhiJ0ruL8DiIddzW+K5+5oExSjLEq1Z4+8YCVwaS+5VaAbwyAq8EpHIvtWJZD7C4uX+xIMdjb/8lsl+UbPUDAAHxdumecHsaMQzAxZuEJ0fSqeK/1CEPpI55NrRXQHgOP+9Bmrumb/fLrRBZrofBRsjFBvIbkNqhsmALZLHNnS3pzZPz7X47m3O8CzALrGPf/tn2fOrx1/a/VEy2jEr1Owsa1uP3lzczE27SAECypYtKfACcGFz7gt/dNHIqSz88i/d8J2C4IKZjZkhIKNW2vfUHKFFvX7y/yorEIC3ZJK5F6qotgQFQp2yRrTnvuIAGkATZOw4bOBgzWdzdmfJmHWlBxBwcqsrWfIvdMJsBvA3Bq2mldxHuiIHz5Qw4wpX6VgISss3asfSHGTqjwJwQzTphW7Y3CefqzlcN7Ua8AwBZtgqf0nWxcGMTyvIg8LcF14XP8WyBdF4L3ORPaHBnSlqiNRMAO2/sGlNwTiL4NgoQBXBpDAERlS1QF/eGQ/P4Du/zApmEEwRu0EKJidGRsGAhTMAItROwEKZmfGhoEABTPAYtROgILZmbFhIEDBDLAYtROgYHZmbBgIUDADLEbtBCiYnRkbBgIUzACLUTsBCmZnxoaBAAUzwGLUToCC2ZmxYSBAwQywGLUToGB2ZmwYCFAwAyxG7QQomJ0ZGwYCFMwAi1E7AQpmZ8aGgQAFM8Bi1E6AgtmZsWEgQMEMsBi1E/gHsBpgVD70V0oAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-45"
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "X")))), _image14 || (_image14 = /*#__PURE__*/React.createElement("image", {
    x: 61,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-46"
  }, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 101
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Y")))), _image15 || (_image15 = /*#__PURE__*/React.createElement("image", {
    x: 101,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABIpJREFUeF7t2l1oHGUUBuD3bNJEEf9KdtYWSam02J3EgFjwQsGAF0IR8cLEH3a2JUiL+IeK1jvBG7FUEakgiBZ3V8GAiILghVAt6IVaQUtmq4b2ojV2Z6laKaVJNntkS4SQfrOZrD0XmX339jtzyPeehy87syPghwkYJiCGvdmaCYDAiMA0AQIzjZfNCYwGTBMgMNN42ZzAaMA0AQIzjZfNCYwGTBMgMNN42ZzAaMA0AQIzjZfNuxpYJfInFRiLYfBL4IXbkhAp1/zXIHjWVavAkaIXbk/SJ401XQ2sVB/eLtr8Pm6wonJnITf1TbvBH9LR3lP16BSAnKtOoA8VvOpHacSTZE9dDawVUDnKHwJkNCasg4EXTrQLslz374Pi05iaE/3ZcOu4YCHJMNJY0/XASlF+h0A+jxnuuX5gw7gXnosbfrnmfwLB/THrTwZeeCCNcJLuqeuBqULKkX9UBEPu71D6aNGrvutae++PLdl1PX2/A1jnWD9zvnHl4J6NR84nHUYa67oeWGuopcjfJcBB94D128Cr3uFaK9WHnhHV150wFS8Xc+FLaUSzmj0RGIBJ9ftm6zgBYKMrvJ5MT/6RgaPHlq+VI/9nALc4rrkwvzA3OLFhur6aYaSxlsAWp1qq5V8QkVedd4Ii+wrZqb1L1z6ob7utqZkfYk6vt4u58LE0glntnghsMbHJP2+6drZxxUkAVy8PUYGTQTbcJAL9b60S5Q8o5HFH4E1Abg68qenVDiON9QS2ZKqlmr9fBM85TyVpjhazx75urb3525b+667pmxHBekftx4EXPpBGLJ3sicCWpFY5M3KjLjSOu+4KVfWdYq66e/GmYEyASVfgzQxu3zkQftfJMNJ4DYEtm2qlPlRS1cAx7L//Ojt3w1Nbp2fLkd96brbDUXM48MK70gil0z0R2LLk3q8Nj2Sk+ZPzyz5krNnsOSyZRuvZV+8lNaL3Btlq3EPbTme0pq8jMMf4KpH/hQL3XLKk+Ewz8pXz2ZciLHjh8NIbgTUt4zL98QTmAnbav1sz+NKxNA/FDASbHGsTgRfGPKy9TNNag20ILGZo5cj/EcCtCWc605/F5nEJ5xLWd00ZgcUBqw89DNUPk0hQ1b3FXHVfktpuqyGwmIlffM8riqZj/h0uveqf/t4Lg+Prj5/tNjxJ9ktgbVIqR/mnAXmjbZCC/UE2fD5J2N1YQ2Btpl46PXKVZBqtn4+ujymbb2Yam3cO/Np6bMGPIwECW4FFu/ftWy9iBF74IGXFJ0BgK+ioRP6LCrziKhPoWwWv+gSBEVjHBgis4+guXsgTjCfY/xO0wtUERmAEZpoAgZnGyxOMwAjMNAECM42XJxiBEZhpAgRmGi9PMAIjMNMECMw0Xp5gpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJvAvj11NVPB81VAAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-47"
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Z")))), _image16 || (_image16 = /*#__PURE__*/React.createElement("image", {
    x: 141,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAA9BJREFUeF7t3E9Ik3EcBvDnty3TAktim1SHIkP2aqFBdCroz7mEpCidYRJCh24JHbp1SOieB2Hl7A8GSUG3kg6dAkFSX4skg4jYRmiBlrrtVwODEXv1fce+oPs9Xv2+D3uf72fv3N6hAn/YgGADSjCb0WwABEYEog0QmGi9DCcwGhBtgMBE62U4gdGAaAMEJlovwwmMBkQbIDDRehlOYDQg2gCBidbLcAIDEJvZUxnYuuVXqTlkgaOXQvabUudupDwCIzBRrwRGYAQm2gCBidbLK5gcsGWdzdR31H6YEd3gOg8nMCFgCupWe2jy5jrfv/jDI7CVimNJq9Zt2wGlFbR6AaC50DEaeD/3Y6np2v7pRbeZ5TpHYEVsNp6yuqHR53CozgLHTP944l83BOYR2KNU/c609tsAthU8VKm70eDkVY+xZTtOYB5XG09Yw1BocTjsq/IvWe07pn96jC3bcQLzsNrBZEOrhn7ieIjCmWjQfu4hsuxHCczlimOzTdsDy0tTAJzeDAxFQ/Z5l3HGjBGYy1XHk1Y/gC6H8Vm/9kUuhicSLuOMGSMwF6t+kGo4ntV6ZJXRy9GQHXMRZdwIga2x8qEvu6sWN1e/A1BXcFTjVTRsnzJOjssTJrA1ihpMNfRqrXscxhZ8Wf+BttrxTy77Nm6MwFZZ+f2k1ewD3gIIOFy9rkfD9h3j1Hg4YQJzKGtIw7+YsnK4DhUa0cBoZdA+ck4h46Fv40YJzGHlA4lIj1Kq1+HXaR9wuC1kjxknxuMJE1iBwu4lGvf5VWYcUFUOV6/bHSH7hseujRwnsAJrjyesl1A46SDiY3p+4WDn3s+/jRTj8aQJ7L/CBpKRLgWV+1C18MVL+U5EgxOvPfZs7DiB5a3+YaIxnFHZ3O2gmsIiVH80NHnFWC1FnDiB5ZUWT1q5G9mtDj1+S2+qsDprxuaK6NnYQwhsZfXxlHUaGs+cJGjtO9sRnnhqrJQiT5zA/t4DGvxeV60zFbkvEe5y+MtrJK3Q5rnj+YU5098MEBiAeMLqg0K3Z0BrHKCVvtARnHpc6tyNlGc8sJXbQaNA6f8hMoEJlLqRnl25xxpPRFqg1LDE4yYwAiMwiWdWXqbxL5G8gskKIzC+RIoKMx6YaLsML/07J3bKBvIb4BWMHkQbIDDRehlOYDQg2gCBidbLcAKjAdEGCEy0XoYTGA2INkBgovUynMBoQLQBAhOtl+EERgOiDRCYaL0MJzAaEG2AwETrZTiB0YBoAwQmWi/DCYwGRBsgMNF6GU5gNCDaAIGJ1stwAqMB0QYITLRehv8Bki/uRYI6BSwAAAAASUVORK5CYII="
  })))))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 479.5 220 L 479.5 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 474.17 239.53 L 479.5 255.53 L 484.83 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 559.5 220 L 559.5 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 554.17 239.53 L 559.5 255.53 L 564.83 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 639.5 220 L 639.5 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 634.17 239.53 L 639.5 255.53 L 644.83 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 239.5 220 L 239.5 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.17 239.53 L 239.5 255.53 L 244.83 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-52"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 319.5 220 L 319.5 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 314.17 239.53 L 319.5 255.53 L 324.83 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-53"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-54"
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 200,
    width: 160,
    height: 80,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 78,
      height: 1,
      paddingTop: 120,
      marginLeft: 432
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Decryption")))), _image17 || (_image17 = /*#__PURE__*/React.createElement("image", {
    x: 432,
    y: 111,
    width: 78,
    height: 23,
    xlinkHref: "data:image/png;base64,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"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.bd317e1da3fd46f35091a8e706f0ccd2.svg";
export { ForwardRef as ReactComponent };